/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone"
import EmojiConvertor from 'emoji-js'
moment.locale('ja')

const KEY_LOGINUSER = 'LOGINUSER'
export interface UsersState {
  activeUsersBefore: Array<any>
  activeUsers: Array<any>
  lastHistory: string
  informations: Array<any>
  logs: Array<any>
  isStarted: boolean
  needToPlaySound: boolean
  changeTypes: Array<any>
  reactionByPerson: Array<any>
  currentProject: string
  [key: string]: any
}

const Users = defineModule({
  state: (): UsersState => {
    return {
      activeUsersBefore: [],
      activeUsers: [],
      lastHistory: '',
      informations: [],
      logs: [],
      isStarted: false,
      needToPlaySound: false,
      changeTypes: [],
      reactionByPerson: [],
      currentProject: ''
    }
  },
  getters: {
    userImageUrl: (...args): string => {
      return Lib.Ajax.apiUrl('/api/userimage/image/')
    }
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async getUsers(context): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/getusers', "Failed to receive Users", {}, rootState.Login.accessToken)
      var users = retval.data.data
      users.forEach((element: any) => {
        element.isAdmin = element.roles.includes('Admin')
      });
      return users
    },
    async activeUsers(context): Promise<any> {
      const { rootState, state, dispatch } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/activeusers', "Failed to receive Active Users", {}, rootState.Login.accessToken)
      var users = retval.data.data
      await dispatch.handleActiveUsers(users)
      return state.needToPlaySound
    },
    async handleActiveUsers(context, users): Promise<any> {
      const { commit, rootState } = moduleActionContext(context, Users)
      var emoji = new EmojiConvertor()
      emoji.replace_mode = 'img'
      emoji.allow_native = false
      emoji.img_sets.apple.path = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@5.0.1/img/apple/64/'
      users.forEach((element: any) => {
        if (element.emojiName != null) {
          var emojiName = (element.emojiName != null && element.emojiName.length > 0 && element.emojiName[0] != ':') ? ':' + element.emojiName + ':' : element.emojiName
          if (element.emojiURL == null || element.emojiURL == "") {
            element.emoji = emoji.replace_colons(emojiName)
          } else {
            element.emoji = "<img width='24' height='24' src='" + element.emojiURL +  "'/>"
          }
        }
        element.displayNameDisp = element.displayName
        if (rootState.Home.isPrivacyMode) {
          element.statusMessage = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
            return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
          }, element.statusMessage)
          element.displayNameDisp = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
            return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
          }, element.displayNameDisp)
        }
      })
      commit.SET_VALUE({name: 'activeUsers', value: users})
      commit.SET_VALUE({name: 'isStarted', value: false})
    },
    async soundPlayed (context): Promise<any> {
      const { commit } = moduleActionContext(context, Users)
      commit.SET_VALUE({name: 'needToPlaySound', value: false})
    },
    async userWithDisplayName(context, DisplayName): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      var startDay = moment().add(-1 * moment().isoWeekday() + 1 - 7, 'd')
      if (moment().isoWeekday() >= 5) {
        startDay = startDay.clone().add(7,'d')
      }
      var endDay = startDay.clone().add(14, 'd')
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/userwithcomments/' + DisplayName, "Failed to receive User", {startday : startDay.format('YYYY-MM-DD'), endday : endDay.format('YYYY-MM-DD')}, rootState.Login.accessToken)
      var users = retval.data.data
      users.weeklyPostedGMTM = users.weeklyPosted == null ? null : moment.tz(users.weeklyPosted, 'Etc/GMT')
      var diffDate = users.weeklyPostedGMTM == null ? null : (moment().diff(users.weeklyPostedGMTM.tz(moment.tz.guess()), 'days'))
      users.weeklyPostedDate = diffDate == null ? '' : ((diffDate == 0) ? users.weeklyPostedGMTM.tz(moment.tz.guess()).format('今日HH:MM') : diffDate + '日前')
      if (users.datePlannings == null) {
        users.datePlannings = []
      }
      if (rootState.Home.isPrivacyMode) {
        users.displayName = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
          return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
        }, users.displayName)
      }
      users.firstPlannings = []
      users.secondPlannings = []
      users.datePlannings.forEach((element: any) => {
        element.dateDisp = moment(element.date).format('M月D日(dd)')
        if (rootState.Home.isPrivacyMode) {
          element.plan = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
            return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
          }, element.plan)
        }
        if (users.firstPlannings.length < 7){
          users.firstPlannings.push(element)
        }else{
          users.secondPlannings.push(element)
        }
      })
      if (rootState.Home.isPrivacyMode) {
        users.weekly = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
          return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
        }, users.weekly)
      }
      var emoji = new EmojiConvertor()
      emoji.replace_mode = 'img'
      emoji.allow_native = false
      emoji.img_sets.apple.path = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@5.0.1/img/apple/64/'
      var comments = users.comments
      comments.forEach((element: any) => {
        element.updatedGMTM = moment.tz(element.updatedAt, 'Etc/GMT')
        element.updatedDate = element.updatedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD')
        element.updatedTime = element.updatedGMTM.tz(moment.tz.guess()).format('HH:mm')
        element.updated = element.updatedGMTM.tz(moment.tz.guess()).format('M/D dd HH:mm')
        if (element.emojiName != null) {
          var emojiName = (element.emojiName != null && element.emojiName.length > 0 && element.emojiName[0] != ':') ? ':' + element.emojiName + ':' : element.emojiName
          if (element.emojiURL == null || element.emojiURL == "") {
            element.emoji = emoji.replace_colons(emojiName)
          } else {
            element.emoji = "<img width='24' height='24' src='" + element.emojiURL +  "'/>"
          }
        }
        if (rootState.Home.isPrivacyMode) {
          element.message = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
            return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
          }, element.message)
        }
      })
      return users
    },
    async getLogs(context): Promise<any> {
      const { commit, rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/log', "Failed to receive Log", {}, rootState.Login.accessToken)
      var logs = retval.data.data
      logs.forEach((element: any) => {
        element.time = moment.tz(element.eventGMT, 'Etc/GMT').tz(moment.tz.guess()).format('HH:mm')
      });
      commit.SET_VALUE({name: 'logs', value: logs})
      return logs
    },
    async getRecurringWithReaction(context): Promise<any> {
      const { rootState, commit, dispatch, state, rootGetters, rootDispatch } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/recurringv3', "Failed to receive Log", {}, rootState.Login.accessToken)
      var logs = retval.data.data.log
      logs.forEach((element: any) => {
        element.time = moment.tz(element.eventGMT, 'Etc/GMT').tz(moment.tz.guess()).format('HH:mm')
      });
      commit.SET_VALUE({name: 'logsBefore', value: JSON.parse(JSON.stringify(state.logs))})
      commit.SET_VALUE({name: 'logs', value: logs})
      var hasChange = false
      var changeTypes: Array<any> = []
      var message = ""
      var logsnew = logs.filter((element:any) => { return !state.logsBefore.reduce((prev: boolean, current: any) => {return (prev || current.serviceEventId == element.serviceEventId)}, false) })
      var toDispUsers = rootGetters.Home.activeUsers
      if (state.logsBefore.length > 0) {
        logsnew.forEach((element: any) => {
          if (element.serviceEventAction == 3) { // 開始
            if (rootState.Home.onlyDisplayingUsers) {
              if (!toDispUsers.reduce((prev: boolean, current: any) => {return prev || current.displayName == element.displayName}, false)) { return }
            }
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('started')) {changeTypes.push('started')}
          }
          if (element.serviceEventAction == 5) { // 終了
            if (rootState.Home.onlyDisplayingUsers) {
              if (!toDispUsers.reduce((prev: boolean, current: any) => {return prev || current.displayName == element.displayName}, false)) { return }
            }
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('ended')) {changeTypes.push('ended')}
          }
          if (element.serviceEventAction == 12) { // コメント
            if (rootState.Home.onlyDisplayingUsers) {
              if (!toDispUsers.reduce((prev: boolean, current: any) => {return prev || current.displayName == element.displayName}, false)) { return }
            }
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('comment')) {changeTypes.push('comment')}
          }
          if (element.serviceEventAction == 11 && element.toDisplayName == rootState.Login.userInfo.displayName) {
            hasChange = true // リアクション
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('reaction')) {changeTypes.push('reaction')}
          }
          if (element.serviceEventAction == 4) { // イメージアップロード
            if (rootState.Home.onlyDisplayingUsers) {
              if (!toDispUsers.reduce((prev: boolean, current: any) => {return prev || current.displayName == element.displayName}, false)) { return }
            }
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('picture')) {changeTypes.push('picture')}
          }
          if (element.serviceEventAction == 13 || element.serviceEventAction == 14) { // 週報
            if (rootState.Home.onlyDisplayingUsers) {
              if (!toDispUsers.reduce((prev: boolean, current: any) => {return prev || current.displayName == element.displayName}, false)) { return }
            }
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('weekly')) {changeTypes.push('weekly')}
          }
          if (element.serviceEventAction == 16) { // 休暇承認
            if (rootState.Home.onlyDisplayingUsers) {
              if (!toDispUsers.reduce((prev: boolean, current: any) => {return prev || current.displayName == element.displayName}, false)) { return }
            }
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('vacation')) {changeTypes.push('vacation')}
          }
          if (element.serviceEventAction == 2) { // エラー
            hasChange = true
            message = message + (message != "" ? "\n" : "") + element.time + ' ' + element.message
            if (!changeTypes.includes('error')) {changeTypes.push('error')}
          }
        })
      }
      commit.SET_VALUE({name: 'lastHistory', value: message})
      commit.SET_VALUE({name: 'needToPlaySound', value: hasChange})
      commit.SET_VALUE({name: 'changeTypes', value: changeTypes})
      var users = retval.data.data.activeUsers
      await dispatch.handleActiveUsers(users)
      var timesheets = retval.data.data.timesheets
      await rootDispatch.Timesheet.handleTimesheets({timesheets: timesheets, current: true})
      var reactions = retval.data.data.reactions
      var reactionByPerson: any[] = []
      reactions.forEach((element: any) => {
        var emoji = new EmojiConvertor()
        emoji.replace_mode = 'img'
        emoji.allow_native = false
        emoji.img_sets.apple.path = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@5.0.1/img/apple/64/'
        var emojiName = (element.emojiName != null && element.emojiName.length > 0 && element.emojiName[0] != ':') ? ':' + element.emojiName + ':' : element.emojiName
        if (element.emojiURL == null || element.emojiURL == "") {
          element.emoji = emoji.replace_colons(emojiName)
        } else {
          element.emoji = "<img width='20' height='20' src='" + element.emojiURL +  "'/>"
        }
        element.posted = moment.tz(element.postedGMT, 'Etc/GMT').tz(moment.tz.guess()).format('HH:mm')
        if (!reactionByPerson.reduce((prev, current) => {
          if (current.toDisplayName == element.toDisplayName) {
            current.emojis.push(element)
            return true
          }
          return prev
        }, false)) {
          reactionByPerson.push({
            toDisplayName: element.toDisplayName,
            emojis: [element]
          })
        }
      })
      commit.SET_VALUE({name: 'reactionByPerson', value: reactionByPerson})
      var informations = retval.data.data.informations
      commit.SET_VALUE({name: 'informations', value: informations})
      commit.SET_VALUE({name: 'currentProject', value: retval.data.data.currentProject ?? ''})
    },
    async update(context, item): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      var Value = JSON.stringify({ displayName: item.displayName, slackId: item.slackId, familyName1: item.familyName1, firstName: item.firstName, lastName: item.lastName, telephoneNumber: item.telephoneNumber, familyName2: item.familyName2, familyName3: item.familyName3, familyName4: item.familyName4, familyName5: item.familyName5, hasSubUser: item.hasSubUser, isExporting: item.isExporting, migrationReference1: item.migrationReference1, isAdmin: item.isAdmin, supplimentalName: item.supplimentalName, calendarGroupId: item.calendarGroupId, ignoreTimesheet: item.ignoreTimesheet, approvalManager: item.approvalManager, teamsUserId: item.teamsUserId, userEmploymentIsActive: item.userEmploymentIsActive})
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/update/' + item.aspNetId, "Failed to update Users", {Value}, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async updatePersonal(context, item): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      var Value = JSON.stringify({ familyName1: item.familyName1, firstName: item.firstName, lastName: item.lastName, telephoneNumber: item.telephoneNumber, familyName2: item.familyName2, familyName3: item.familyName3, familyName4: item.familyName4, familyName5: item.familyName5 })
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/update/' + item.aspNetId, "Failed to update Users", {Value}, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async add(context, { email, password, role }): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.postHandleError<any>('/api/user/add', "Failed to update Users", { Email: email, Password: password, Role: role }, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async changePassword(context, { aspNetId, newPassword }): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.postHandleError<any>('/api/user/changepassword', "Failed to update Users", { AspNetId: aspNetId, NewPassword: newPassword }, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async sendReaction(context, { toDisplayName, emojiName, privateMessage }): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/reaction/sendreaction', "Failed to send reaction", { toDisplayName, emojiName, privateMessage }, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async getAuthCode(context): Promise<string> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/authentificationcode', "Failed to get Auth Code", {}, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async getTenantTeamsMembers(context): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/user/tenantteammembers', "Failed to get Teams Member list", {}, rootState.Login.accessToken)
      var user = retval.data.data
      user.forEach((element:any) => {
        element.displayName = element.name + '(' + element.email + ')' 
      })
      return user
    },
    async sendStatusMessage(context, { emojiName, statusMessage }): Promise<any> {
      const { rootState } = moduleActionContext(context, Users)
      const retval = await Lib.Ajax.getHandleError<any>('/api/statusmessage/send', "Failed to send status message", { emojiName, statusMessage }, rootState.Login.accessToken)
      var user = retval.data.data
      return user
    },
    async updateImage(context, {File, AspNetId, ImageType}): Promise<any>  {
      const { rootState } = moduleActionContext(context, Users)
      var body = new FormData()
      body.append('Picture', File);
      body.append('AspNetId', AspNetId);
      body.append('FileName', File.name);
      body.append('ImageType', ImageType);
      body.append('Width', '0');
      body.append('Height', '0');
      var path = '/api/user/updateimage';
      var options = {
        'Accept': 'application/json'
      };
      const url = Lib.Ajax.apiUrl(path);
      const headers = Object.assign(Lib.Ajax.apiOption(rootState.Login.accessToken), options);
      var res = await fetch(url, {
        method: 'POST',
        headers,
        body
      }) as any;
      var data = await res.json();
      res.data = data;
      const retval = res;
      if (retval.statusText != 'OK') {
        throw new Error('添付ファイルの登録に失敗しました');
      }
      return retval.data;
    }
  },
  namespaced: true
})

export default Users